/* eslint-disable */
export default {
  title: 'Audio',
  dialButtonVolume: 'Dial button volume',
  ringtoneVolume: 'Ring tone volume',
  callVolume: 'Call volume',
  muteCalls: 'Mute calls',
  outputDevice: 'Output device',
  inputDevice: 'Input device',
  micPermission: 'Microphone permission',
  noDevice: 'No device',
  checkMicPermission: 'Check permission',
  micNoPermissionMessage:
    'The app does not have permission to use the microphone',
  noLabel: 'Unknown device',
  notSetSinkIdTip:
    'Sorry, your current browser permissions are not set to allow us to access your audio output devices. {clickHereLink} to see how to set up.',
  noLabelTip:
    'Sorry, your current browser permissions are not set to allow us to access your audio input devices.',
  clickHere: 'Click here',
  defaultOutputDevice: 'Default output device',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
